module.exports = __webpack_public_path__ + "img/tc-qr.714b3f22.png";